import React, { memo, useCallback } from 'react';

import Popup from '../helpers/Popup';
import FormGroup from '../helpers/FormGroup';
import Button from '../helpers/Button';
import BaseInput from '../helpers/Input';
import ErrorDisplay from '../decorators/DisplayError';
import PrettyError from '../decorators/PrettyError';
import copyToClipboard from '../../utils/copyToClipboard';

const Input = PrettyError(ErrorDisplay(BaseInput));

const EmailFinderPopup = props => {
  const { onChange, finder, onFind } = props;
  const isLoading = finder.get('loading');
  const email = finder.getIn(['data', 'email'], null);

  const handleCopyClick = useCallback(() => copyToClipboard(email), [email]);

  const footer = (
    <Button className="btn-primary" disabled={isLoading} onClick={onFind}>
      Find
    </Button>
  );

  return (
    <Popup footer={footer} header="Email Finder" id="findEmail" loading={isLoading}>
      <div className="row">
        <FormGroup className="col-lg-6 col-sm-6">
          <Input
            className="input-md"
            label="Full Name"
            name="fullName"
            onChange={onChange}
            placeholder="John Doe"
            root={finder}
            autoFocus
            showLabel
          />
        </FormGroup>
        <FormGroup className="col-lg-6 col-sm-6">
          <Input
            className="input-md"
            label="Company Domain Name"
            name="domain"
            onChange={onChange}
            placeholder="company.com"
            root={finder}
            showLabel
          />
        </FormGroup>
      </div>
      {email && !isLoading && (
        <div className="d-flex align-items-center justify-content-space-between">
          <strong>
            {email} <i className="text-success fa fa-check" />
          </strong>
          <Button onClick={handleCopyClick}>
            <i className="fa fa-clipboard mr8" />
            Copy to Clipboard
          </Button>
        </div>
      )}
    </Popup>
  );
};

export default memo(EmailFinderPopup);
